import { t } from '../../i18n'

/**
 * 倍速。
 *
 * 和清晰度一样记在本地：选过一次就一直按选的来，跨集跨会话。
 * 短剧的人要么一路 1 倍看，要么一路 2 倍刷，没有「每集重新决定」这回事。
 */
const STORAGE_KEY = 'drama.rate'

export const DEFAULT_RATE = 1

/** 可选的倍速。3 倍是上限：再快音频在多数浏览器里会直接静音。 */
export const RATES = [0.75, 1, 1.25, 1.5, 2, 3]

export function loadRate(): number {
  try {
    const n = Number(localStorage.getItem(STORAGE_KEY))
    // 只认清单里有的值。存进来一个 7 倍不是我们给的，别拿去设
    return RATES.includes(n) ? n : DEFAULT_RATE
  } catch {
    // 隐私模式下 localStorage 会抛，不能让它把播放带崩
    return DEFAULT_RATE
  }
}

export function saveRate(rate: number): void {
  try {
    localStorage.setItem(STORAGE_KEY, String(rate))
  } catch {
    // 存不下就只在这一次播放里生效，不是错误
  }
}

const LOCK_KEY = 'drama.rateLocked'

/**
 * 长按两侧上滑锁定的 2 倍速。和手动选的倍速分开记：锁定的要能被
 * 「再长按、下滑退出」解掉，手动选的不行。跨集跨会话保持，和倍速本身一样。
 */
export function loadRateLocked(): boolean {
  try {
    return localStorage.getItem(LOCK_KEY) === '1'
  } catch {
    return false
  }
}

export function saveRateLocked(locked: boolean): void {
  try {
    if (locked) localStorage.setItem(LOCK_KEY, '1')
    else localStorage.removeItem(LOCK_KEY)
  } catch {
    // 同 saveRate
  }
}

/**
 * 按钮上那个字。1 倍写成 1.0x，不写成 1x——一排数字对齐好看些。
 * 单位后缀走 i18n 模板（`rate.unit`），界面上出现的每一个字都必须来自 `km.ts`。
 */
export function rateLabel(rate: number): string {
  return t.rate.unit.replace('{n}', rateNumber(rate))
}

/** 不带单位的那个数（2.0、1.25），给已经自带单位的整句文案用（长按顶速的黑条、锁定结论）。 */
export function rateNumber(rate: number): string {
  return rate.toFixed(2).replace(/0$/, '').replace(/\.$/, '.0')
}
